export default class FadeInElement {
  constructor(element) {
    this.element = element;
    this.initObserver();
  }

  static init() {
    document.querySelectorAll('[data-scroll-transition="fade"]').forEach(el => new FadeInElement(el))
  }

  initObserver() {
    this.observer = new IntersectionObserver(this.callback.bind(this), {})
    this.observer.observe(this.element);
  }

  callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fadeIn')
        this.observer.disconnect();
      }
    })
  }
}

